// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"49f4265b","346":"52c12f2f","377":"b0ebf188","379":"6f61b089","519":"8fd81c2c","541":"470cdc6d","839":"88f378a3"}[chunkId] + ".chunk.js";
};